/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum FuelControllerPriceControlSchemeApiModel {
  None = 'none',

  PriceFromSystem = 'price-from-system',

  PriceFromController = 'price-from-controller'
}
